const formatTime = (time) => {
  const timeString = `${time}`
   return  time < 1000
      ? `0${timeString.substring(0, 1)}:${timeString.slice(1)}`
      : `${timeString.substring(0, 2)}:${timeString.substring(2)}`
}

export default formatTime
